import React, { FC, useState } from 'react';
import { palette } from '../../theme';

export interface COEActionBarProps {
  items: string[];
  selectedItem: string;
  setSelectedItem: any;
  disabled?: boolean;
  padding?: string;
  fontSize?: number;
  marginTop?: number;
}

const COEActionBarComponent: FC<COEActionBarProps> = (props) => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const handleSelection = (val: string) => {
    props.setSelectedItem(val);
  };

  return (
    <div style={{ flexWrap: 'wrap', display: 'flex', gap: 6, paddingTop: 8, paddingBottom: 4 }}>
      {props.items?.map((item) => {
        const isSelected = props.selectedItem === item;
        const isHovered = hoveredItem === item && !props.disabled;
        return (
          <button
            onClick={() => handleSelection(item)}
            key={item}
            disabled={props.disabled}
            onMouseEnter={() => setHoveredItem(item)}
            onMouseLeave={() => setHoveredItem(null)}
            style={{
              padding: '5px 14px',
              borderRadius: 20,
              backgroundColor: isSelected
                ? palette.primary.light
                : isHovered
                ? palette.grey[50]
                : palette.background.paper,
              border: isSelected ? `2px solid ${palette.primary.main}` : `1px solid ${palette.divider}`,
              color: isSelected ? palette.primary.main : palette.text.primary,
              fontSize: props.fontSize ? props.fontSize : 13,
              fontWeight: isSelected ? 600 : 400,
              height: 34,
              cursor: props.disabled ? 'default' : 'pointer',
              transition: 'all 0.12s ease',
              fontFamily: 'inherit',
              opacity: props.disabled ? 0.5 : 1,
              whiteSpace: 'nowrap' as const,
            }}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
};

export default COEActionBarComponent;
